export default "__VITE_ASSET___4bgKwUF__"